module.exports = __webpack_public_path__ + "img/perforaciones2_4-3.74606d8e.jpg";